import {
    ADMINCLUB_MENU,
    DELETE_AVATAR,
    TICKETS_TITLE,
} from 'mk/autogenerated/translations/ProfileAdminTools.c40807de754dd687071fc1d98f8b5e03'
import { adminclubTickets, adminclubUsers } from 'mk2/apps/adminclub/urls';
import { capitalizeFirstLetter } from 'mk2/apps/strollers/helpers';
import { GENERIC_AVATAR_PATH } from 'mk2/apps/users/utils';
import { Btn,  BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Dot } from 'mk2/components/Dot';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ProfileAdminTools.mscss';

interface OwnProps {
    user: UserEntity;
    onlineStatus: string;
    onDeleteAvatarByAdmin(username: string);
}

class ProfileAdminTools extends React.Component<OwnProps> {

    public render() {
        const { onlineStatus, user } = this.props;

        if (!user) {
            return null;
        }

        return (
            <div className={styles.ProfileAdminTools}>

                {onlineStatus && (
                    <>
                        <span className={styles.ProfileAdminTools__item}>
                            {capitalizeFirstLetter(onlineStatus)}
                        </span>
                        <Dot spaces={1} />
                    </>
                )}

                {user.avatar && !user.avatar.includes(GENERIC_AVATAR_PATH) && (
                    <>
                        <span className={styles.ProfileAdminTools__item}>
                            <Btn
                                type={BtnType.AdminTextLight}
                                label={DELETE_AVATAR}
                                onClick={this.handleDeleteAvatar}
                                sidePadding={BtnSidePadding.None}
                            />
                        </span>
                        <Dot spaces={1} />
                    </>
                )}


                <span className={styles.ProfileAdminTools__item}>
                    <Btn type={BtnType.AdminTextLight} label={ADMINCLUB_MENU} link={url(adminclubUsers, {}, {user: user.username})} sidePadding={BtnSidePadding.None} />
                </span>

                <Dot spaces={1} />

                <span className={styles.ProfileAdminTools__item}>
                    <Btn type={BtnType.AdminTextLight} label={capitalizeFirstLetter(TICKETS_TITLE)} link={url(adminclubTickets, {}, {new_ticket_name: user.username})} sidePadding={BtnSidePadding.None} />
                </span>
            </div>
        );
    }

    private handleDeleteAvatar = () => {
        const { onDeleteAvatarByAdmin, user } = this.props;
        onDeleteAvatarByAdmin(user.username);
    };

}

export default ProfileAdminTools;
